import { RnUsersVM } from 'src/app/shared/services/rnapi2-service/models/models';

export class UserPackageChangeOptionsConfiguration {
  public packageTypes: { [key: string]: number[] };
  public totalPackages: number;

  constructor(public users: RnUsersVM[], public isPurchasable: string, public showDeleteUserText = true) {
    this.packageTypes =
      users?.reduce<Record<string, number[]>>((r, a) => {
        for (const b of a.DirectBilledPackages ?? []) {
          if (r[b]) {
            r[b].push(a.UserID);            
          } else {
            r[b] = [a.UserID];
          }
        }
        return r;
      }, {}) ?? {};

    this.totalPackages =
      users?.filter((p) => p.DirectBilledPackages?.length).reduce((r, a) => r + a.DirectBilledPackages.length, 0) ?? 0;
  }
}
